/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SessionContext } from '../../../context/SessionContext';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import { Link } from '../../../components/Link/Link';
import {
  buildNativeDownloadUrl,
  buildWebAppJoinDisplayUrl,
  buildWebAppJoinUrl,
} from '../../../services/UrlService';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';

const messages = defineMessages({
  heading: {
    id: 'error.heading',
  },
  troubleshootingInstructions: {
    id: 'error.troubleshooting.instantJoin',
  },
  nativeDownload: {
    id: 'error.troubleshooting.nativeDownload',
  },
  downloadLink: {
    id: 'error.troubleshooting.nativeDownload.link',
  },
});

export const Error: React.FC = () => {
  const { meetingId, sessionTrackingId, openerLaunchToken, webAppUrl } =
    useContext(SessionContext);
  const { formatMessage: f } = useIntl();
  const instantJoinUrl =
    webAppUrl || buildWebAppJoinUrl(meetingId, sessionTrackingId);
  const sendTelemetry = useSendTelemetry();
  const displayedInstantJoinUrl = buildWebAppJoinDisplayUrl(meetingId);
  useEffect(() => {
    sendTelemetry(
      TelemetryComponent.Web,
      TelemetryAction.Fail,
      TelemetryState.Error
    );
  });
  return (
    <Flex
      direction='column'
      justifyContent='center'
      alignItems='center'
      id='errorStatus'
      pb='10vh'
    >
      <Text as='h1' color='white'>
        {f(messages.heading)}
      </Text>
      <Flex direction='column' alignItems='center' mt='7vh' color='white'>
        <Text>{f(messages.troubleshootingInstructions)}</Text>
        <Link
          textDecoration='underline'
          href={instantJoinUrl}
          onClick={() =>
            sendTelemetry(
              TelemetryComponent.Web,
              TelemetryAction.Retry,
              TelemetryState.Error
            )
          }
        >
          {displayedInstantJoinUrl}
        </Link>
      </Flex>
      <Flex color='white' mt='7vh'>
        <Text>
          {f(messages.nativeDownload)}
          <Link
            textDecoration='underline'
            href={buildNativeDownloadUrl(openerLaunchToken)}
            onClick={() =>
              sendTelemetry(
                TelemetryComponent.Native,
                TelemetryAction.Download,
                TelemetryState.Error
              )
            }
          >
            {f(messages.downloadLink)}
          </Link>
          .
        </Text>
      </Flex>
    </Flex>
  );
};
